/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import router from "@/router";

export default {
  updateUsername({ commit }, payload) {
    payload.user
      .updateProfile({
        displayName: payload.username
      })
      .then(() => {
        if (payload.closeAnimation) payload.closeAnimation();

        // If username update is success
        // update in localstorage
        let newUserData = Object.assign({}, payload.user.providerData[0]);
        newUserData.displayName = payload.username;
        commit("UPDATE_AUTHENTICATED_USER", newUserData);

        // If reload is required to get fresh data after update
        // Reload current page
        if (payload.isReloadRequired) {
          router.push(router.currentRoute.query.to || "/");
        }
      })
      .catch(err => {
        if (payload.closeAnimation) payload.closeAnimation();

        payload.notify({
          time: 8800,
          title: "Error",
          text: err.message,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
      });
  },

  updateAuthenticatedUser({ commit }, payload) {
    commit("UPDATE_AUTHENTICATED_USER", payload);
  },

  addToken: ({ commit }, payload) => commit("addToken", payload),

  addUser: ({ commit }, payload) => commit("addUser", payload),

  signOut: (undefined, payload) => {
    const { router } = payload;
    const { params } = router.history.current;

    localStorage.clear();
    sessionStorage.clear();

    router.push({
      name: "login",
      params
    });
  }
};
